import { Theme } from '@mui/material';
import { SystemStyleObject } from '@mui/system';

/**
 * Column group header styles for DataGrid with column grouping
 * These styles must be applied via sx prop to maintain proper specificity over MUI defaults
 */

/**
 * Creates the sx prop styles for the sticky column group header and dynamic borders
 * @param lastGroupOneField - The field name of the last column in the first group
 * @param lastGroupTwoField - Optional: The field name of the last column in the second group
 * @param lastGroupThreeField - Optional: The field name of the last column in the third group
 * @returns SxProps object for MUI DataGrid column group header
 */
export const getGroupColumnHeaderStyles = (
  lastGroupOneField: string,
  lastGroupTwoField?: string,
  lastGroupThreeField?: string,
): SystemStyleObject<Theme> => ({
  /* Sticky fixed column positioning */
  // First Sticky fixed column group header, needs to be white
  '.MuiDataGrid-columnHeaders div:nth-of-type(1) .MuiDataGrid-columnHeader:nth-of-type(2)': {
    backgroundColor: '#ffffff',
    position: 'sticky',
    left: 0,
    zIndex: 4,
  },

  /* Dynamic column borders (uses JS variables) */
  // Last column header in first group
  [`& .MuiDataGrid-columnHeader[data-field="${lastGroupOneField}"]`]: {
    borderRight: '2px solid #757575',
  },
  // Last table cell in first group
  [`& .MuiDataGrid-cell[data-field="${lastGroupOneField}"]`]: {
    borderRight: '2px solid #757575',
  },
  // Last column header in second group (optional)
  ...(lastGroupTwoField && {
    [`& .MuiDataGrid-columnHeader[data-field="${lastGroupTwoField}"]`]: {
      borderRight: '2px solid #757575',
    },
  }),
  // Last table cell in second group (optional)
  ...(lastGroupTwoField && {
    [`& .MuiDataGrid-cell[data-field="${lastGroupTwoField}"]`]: {
      borderRight: '2px solid #757575',
    },
  }),
  // Last column header in third group (optional)
  ...(lastGroupThreeField && {
    [`& .MuiDataGrid-columnHeader[data-field="${lastGroupThreeField}"]`]: {
      borderRight: '2px solid #757575',
    },
  }),
  // Last table cell in third group (optional)
  ...(lastGroupThreeField && {
    [`& .MuiDataGrid-cell[data-field="${lastGroupThreeField}"]`]: {
      borderRight: '2px solid #757575',
    },
  }),
});
